import { Component, Input } from '@angular/core';
import {
  BaseWeekDays,
  BaseWeekDaysAlt,
  CustomerInquiryOfferProfileListItemResponse,
  ProfileForAssignmentCustomerResponse,
  WeekdaysArrayAlt,
  BaseShiftIcons,
  BaseShiftsArray,
} from 'base';

@Component({
  selector: 'base-customer-shift-readiness',
  templateUrl: './base-customer-shift-readiness.component.html',
})
export class BaseCustomerShiftReadinessComponent {
  @Input() profile: CustomerInquiryOfferProfileListItemResponse | ProfileForAssignmentCustomerResponse | undefined;

  weekdaysArray: [BaseWeekDays, BaseWeekDaysAlt][] = WeekdaysArrayAlt;
  baseShiftIconsEnum = BaseShiftIcons;
  shifts = BaseShiftsArray;
}
